export default {
  EXISTS_SIZE: `#graphql
  query existsSize($size: String!) {
    existsSize(size: $size)
  }`,

  GET_ALL: `#graphql
  query getSizes($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getSizes(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        size,
        order,
        activeBrands,
        activeSize,
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getSizesHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getSizesHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        size,
        order,
        activeBrands,
        activeSize,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewSize($size: SizeInput!) {
    newSize(input: $size)
    {
      size 
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateSize($size: String!, $sizeUpdate: SizeUpdateInput!) {
    updateSize(size:$size, sizeUpdate: $sizeUpdate)
    {
      size  
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteSize($size: String!) {
    deleteSize(size:$size)
    {
      size
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/size.js